import { FaCode, FaDatabase, FaServer, FaCogs } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const services = [
  {
    title: 'PHP Development',
    description: 'Full stack PHP development with expertise in creating dynamic web applications, internal management systems, and RESTful API integrations.',
    icon: <FaCode size={32} />,
    bg: 'bg-yellow-400/80',
  },
  {
    title: 'Database Management',
    description: 'Skilled in database design, optimization, and management with MongoDB and other database systems for efficient data operations.',
    icon: <FaDatabase size={32} />,
    bg: 'bg-pink-500/80',
  },
  {
    title: 'RESTful API Integration',
    description: 'Expert in integrating third-party shipping partners, payment gateways, and creating robust API connections for seamless operations.',
    icon: <FaServer size={32} />,
    bg: 'bg-green-400/80',
  },
  {
    title: 'Application Maintenance',
    description: 'Proven track record in maintaining and optimizing web applications, ensuring smooth transitions and system performance.',
    icon: <FaCogs size={32} />,
    bg: 'bg-sky-500/80',
  },
];

const Services = () => {
  return (
    <section className="bg-gradient-to-b from-[#1f1f1f] via-[#2d1b3d] to-[#0e0e2c] text-white py-20 px-6 border-b-4 border-purple-500/30">
      <div className="max-w-7xl mx-auto">
        {/* Section Heading */}
        <div className="mb-12 text-center">
          <p className="text-pink-500 font-medium italic">What I do</p>
        <h2
            className="
                text-2xl md:text-2xl font-bold mb-2 inline-block 
                border-b-4 border-transparent hover:border-pink-600 
                pb-1 transition-colors duration-300
            ">
                My Skills & Services
            </h2>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto italic">
            Specialized in PHP development, database management, and creating efficient web solutions with proven experience in logistics and supply chain operations.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${service.bg} text-white p-6 rounded-lg shadow-lg relative overflow-hidden`}
            >
              <div className="z-10 relative">
                <div className="mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold mb-2">{service.title}</h3>
                <p className="text-sm">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Live Demo Section */}
        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-4">🏋️ See My Work in Action</h3>
            <p className="text-purple-100 mb-6">
              Check out my Gym Management Application with BMI Calculator - a full-stack project showcasing my PHP, React, and database management skills.
            </p>
            <Link
              to="/gym-management"
              className="bg-white text-purple-600 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors inline-flex items-center space-x-2"
            >
              <span>🚀 View Live Demo</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
